frappe.provide("jhaudio.checkout");

const currencyFmt = new Intl.NumberFormat("en-US");

jhaudio.checkout.CartBillingAddressWidget = class extends jhaudio.checkout.CartAddressWidgetBase {
  constructor($target, $container, doc) {
    super($target, $container, doc);
    this.$addressWidgetContainer = $target.closest('.address-widget-container');

    this.init();
  }

  async init() {
    const me = this;
    await super.init();
    this.validate();
  }

  async onAddressSelected(address_name) {
    if ( !address_name ) {
      console.warn("Missing address name!");
    }

    await this.update(true);

    if ( this.doc.customer_address != address_name ) {
      try {
        const r = await frappe.call({
          method: "jhaudio.cart.set_order_address",
          args: {
            doctype: this.doc.doctype,
            docname: this.doc.name,
            address: address_name
          },
          freeze: true
        });
        window.location.reload();
      } catch(err) {
        console.error(err);
      }
    }

    await this.update(false);
  }

  async onAddressSave(address) {
    super.onAddressSave(address);
    await this.update(true);

    if ( address.name ) {
      try {
        const r = await frappe.call({
          method: 'jhaudio.cart.update_order_address',
          args: {
            doctype: this.doc.doctype,
            docname: this.doc.name,
            address: address
          },
          freeze: true
        });
      } catch (err) {
        console.error(err);
      }
    } else {
      try {
        address.address_type = "Billing";
        const new_address = await frappe.call('jhaudio.cart.save_order_address', { doc: address });
        const r = await frappe.call({
          method: "jhaudio.cart.set_order_address",
          args: {
            doctype: this.doc.doctype,
            docname: this.doc.name,
            address: new_address.message.name
          },
          freeze: true
        });
      } catch (err) {
        console.error(err);
        await this.update(false);
        return;
      }
    }
    await this.update(false);
    window.location.reload();
  }

  async onValidate() {
    const valid = this.doc.customer_address && !this.updating;

    if ( valid ) {
      this.$target.trigger('valid');
    } else {
      this.$target.trigger('invalid');
    }

    this.$target.trigger('updating', !!this.updating);
  }
}

